import isEqual from "../__compat__/lodash/isEqual.mjs.mjs";
import mapValues from "../__compat__/lodash/mapValues.mjs.mjs";
const isScalar = (unknown) => typeof unknown !== 'object';
const BREAKPOINT_ORDER = ['xs', 's', 'm', 'l', 'xl', 'xxl'];
// reduce 'breakpoints' variable to only contain breakpoints with unique values
export const collapseBreakpoints = (breakpoints) => {
    const [firstBreakpointLabel, ...restBreakpointsLabels] = BREAKPOINT_ORDER.filter((breakpoint) => Boolean(breakpoints[breakpoint]));
    const firstValue = breakpoints[firstBreakpointLabel];
    const collapsedBreakpoints = {
        [firstBreakpointLabel]: firstValue,
    };
    let previousValue = firstValue;
    for (const currentBreakpointLabel of restBreakpointsLabels) {
        const currentValue = breakpoints[currentBreakpointLabel];
        if (currentValue !== previousValue) {
            collapsedBreakpoints[currentBreakpointLabel] = currentValue;
            previousValue = currentValue;
        }
    }
    // if only the 'xs' breakpoint is left return it directly
    return isEqual(Object.keys(collapsedBreakpoints), ['xs'])
        ? (collapsedBreakpoints === null || collapsedBreakpoints === void 0 ? void 0 : collapsedBreakpoints.xs) || collapsedBreakpoints
        : collapsedBreakpoints;
};
const mapStyleValueForBreakpoint = (styleValue, breakpointLabel) => {
    switch (typeof styleValue) {
        case 'function':
            return styleValue(breakpointLabel);
        case 'object':
            return styleValue[breakpointLabel];
        default:
            return styleValue;
    }
};
export const responsiveStyles = (styles, breakpointLabels) => {
    const breakpointKeys = Object.keys(breakpointLabels);
    const unoptimizedBreakpointStyles = mapValues(styles, (styleValue) => {
        const breakpoints = {};
        for (const breakpointLabel of breakpointKeys) {
            breakpoints[breakpointLabel] = mapStyleValueForBreakpoint(styleValue, breakpointLabel);
        }
        return breakpoints;
    });
    const collapsedBreakpointStyles = mapValues(unoptimizedBreakpointStyles, collapseBreakpoints);
    const simpleStyles = {};
    const breakpointStyles = {};
    for (const [key, value] of Object.entries(collapsedBreakpointStyles)) {
        if (isScalar(value)) {
            simpleStyles[key] = value;
        }
        else {
            breakpointStyles[key] = value;
        }
    }
    const simpleStyleStrings = Object.entries(simpleStyles).map(([styleRule, styleValue]) => `${styleRule}:${styleValue};`);
    const breakpointStyleStrings = breakpointKeys
        .filter((breakpointLabel) => Object.values(breakpointStyles).some((breakpoints) => !!breakpoints[breakpointLabel]))
        .map((breakpointLabel) => {
        const minWidth = breakpointLabels[breakpointLabel];
        const serializedStyles = Object.entries(breakpointStyles)
            .filter(([, breakpoints]) => Boolean(breakpoints[breakpointLabel]))
            .map(([styleRule, breakpoints]) => `${styleRule}:${breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints[breakpointLabel]};`)
            .join('');
        return `@media (min-width:${minWidth}px) {${serializedStyles}}`;
    });
    return [...simpleStyleStrings, ...breakpointStyleStrings].join('');
};
//# sourceMappingURL=responsiveStyles.mjs.mjs.map